export default __webpack_public_path__ + "static/media/loader1.573d36ce.svg";